import { render, staticRenderFns } from "./ada-menu.vue?vue&type=template&id=fc055aa8&"
import script from "./ada-menu.vue?vue&type=script&lang=js&"
export * from "./ada-menu.vue?vue&type=script&lang=js&"
import style0 from "./ada-menu.vue?vue&type=style&index=0&id=fc055aa8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports